import { MessageProps } from '../components';
import { BOT_NAME } from '../constants';

export function delay(milliseconds: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}

export function generateUniqueId(): string {
  return Math.random().toString(36).substring(2) + Date.now().toString();
}

export function getMessagesFromText(text: string): Array<[MessageProps, number]> {
  const WPM = 36;

  if (text.includes('|')) {
    const messages = text.split('|');
    return messages.map((message) => [{
      date: new Date(),
      id: generateUniqueId(),
      name: BOT_NAME,
      owner: 'bot',
      text: message
    }, (text.split(' ').length / WPM) * 1000]);
  }
  return [[{
    date: new Date(),
    id: generateUniqueId(),
    name: BOT_NAME,
    owner: 'bot',
    text
  }, (text.split(' ').length / WPM) * 1000]];
}

export function shuffle(list: any[]): any[] {
  return Array.from(list).sort(() => Math.random() - 0.5);
}
